import React from 'react';
import {View, ViewStyle} from 'react-native';

import {SEARCH} from '/enum/filter.enum';
import {withSafeArea} from '/provider/SafeAreaProvider';

import {
  getGeneration,
  getPersonAvatarUrl,
  getPersonFullName,
  getPersonId,
  isCoach,
} from './SearchResultItem/SearchResultItem.util';
import {Filter} from './Filter';
import {styles} from './Search.style';
import {generateOnRecordPress} from './Search.util';
import {SearchHeader} from './SearchHeader';
import {SearchResultItem} from './SearchResultItem';
import {SearchResultsRenderer} from './SearchResultsRenderer';

import {useRecordsFiltering} from '/context/RecordsFilter/useRecordsFiltering';

interface SafeAreaInsets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

interface SearchContentProps {
  recordsShowPopover: () => void;
  recordsShowRecord: (id: string) => void;
  onOrderPress: () => void;
  safeAreaInsets: SafeAreaInsets;
}

export const SearchContent: React.FC<SearchContentProps> = ({
  recordsShowPopover,
  recordsShowRecord,
  onOrderPress,
  safeAreaInsets,
}) => {
  const style: ViewStyle[] = [styles.base];
  if (safeAreaInsets?.top) {
    style.push({paddingTop: safeAreaInsets.top});
  }

  const {filterParam} = useRecordsFiltering({recordsName: SEARCH});

  const renderSearchResultItem = ({
    item,
    isRecentSearch,
  }: {
    item: any;
    isRecentSearch: boolean;
  }) => (
    <SearchResultItem
      id={getPersonId(item)}
      avatarUrl={getPersonAvatarUrl(item)}
      fullName={getPersonFullName(item)}
      generation={getGeneration(item)}
      isCoach={isCoach(item)}
      item={item}
      isRecentSearch={isRecentSearch}
      onPress={generateOnRecordPress({
        item,
        recordsShowPopover,
        recordsShowRecord,
        onOrderPress,
      })}
    />
  );

  return (
    <View style={style}>
      <SearchHeader recordsParams={filterParam.params} />
      <Filter recordsParams={filterParam.params} />
      <SearchResultsRenderer
        recordsParams={filterParam.params}
        renderItem={({isRecentSearch}: {isRecentSearch: boolean}) =>
          ({item}: {item: any}) =>
            renderSearchResultItem({item, isRecentSearch})}
      />
    </View>
  );
};

export const SearchContentConnected = withSafeArea(SearchContent);
